/* eslint-disable no-use-before-define */
import React from 'react'
import { getConfig } from '../twd'

const SHORT_LABELS = {
    muni_in: 'In-state muni',
    muni_out: 'Out-of-state muni',
    corp: 'Corporate',
    tsy: 'Treasury',
}

const pct2 = (a) => {
    let x = Number.parseFloat(a)
    return isNaN(x) ? '-' : (x.toFixed(2) + '%')
}


export const Table = ({calculation}) => {
    let { order, values } = calculation || {}
    if (!order || !values) return null

    const isBlue = getConfig('entitlements.ETradeBlue', 'No') === 'Yes'
    const color = isBlue ? '#e9f2f9' : '#f1ecff'


    return <table 
        style={{padding:'5px', border:'1px solid #c4c4c4'}}
        className="table align-top table-striped">
    <thead>
        <tr>
            {order.map((a,i) => <th
                key={i}
                style={{width:'25%', verticalAlign:'top', paddingRight:'5px'}} 
                className="text-right text-muted text-body"
            >{SHORT_LABELS[a]}</th>)}
        </tr>
    </thead>
    <tbody>
        {values.map( (vs, ri) => {
            return <tr key={ri} style={ri===3 ? {backgroundColor: color} : {}}>
                {order.map((a, ci) => <td
                    key={ri + '-' + ci}
                    className={"text-right" + ((ri===3 || ci===0) ? " text-bold" : "")}
                >{pct2(vs[a] * 100)}</td>)}
            </tr>

        })}
    </tbody>
    </table>
}


// WEBPACK FOOTER //
// ./src/tey-calculator/table.js